import { render } from "./WatchlistContainerItemComponent.vue?vue&type=template&id=12545cd4&scoped=true&ts=true"
import script from "./WatchlistContainerItemComponent.vue?vue&type=script&lang=ts"
export * from "./WatchlistContainerItemComponent.vue?vue&type=script&lang=ts"

import "./WatchlistContainerItemComponent.vue?vue&type=style&index=0&id=12545cd4&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12545cd4"]])

export default __exports__